import { API_BASE } from '../config';
const CHATS_BASE = `${API_BASE}/chats`;

const chatService = {
  async listRooms() {
    const res = await fetch(CHATS_BASE, { credentials: 'include' });
    return res.json();
  },
  async ensureRoom(userId) {
    const res = await fetch(`${CHATS_BASE}/${userId}`, {
      method: 'POST',
      credentials: 'include'
    });
    return res.json();
  },
  async fetchMessages(roomId, before=null) {
    // Build the URL as a plain string — API_BASE is a relative path ("/api") in
    // production (Vercel proxy), and new URL() throws on a relative string.
    let url = `${CHATS_BASE}/${roomId}/messages`;
    if (before) url += `?before=${encodeURIComponent(before)}`;
    const res = await fetch(url, { credentials: 'include' });
    return res.json();
  },
  async sendMessage(roomId, text) {
    const res = await fetch(`${CHATS_BASE}/${roomId}/messages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ text })
    });
    return res.json();
  }
};

export default chatService; 